/**
 * Determines the API base URL based on the provided configuration.
 *
 * SAFETY: This function uses a fail-safe approach where sandbox is the default
 * fallback for any ambiguous or missing configuration. Production URLs are only
 * returned when environment is explicitly set to 'production'.
 *
 * @param config - The configuration object containing environment details and URLs.
 * @returns The resolved API base URL string.
 */
export function getBaseUrl(config) {
    const { environment, previewApiBaseUrl, useSandbox, defaultApiUrl, sandboxApiUrl, localDevelopmentApiUrl, } = config;
    // Convert useSandbox to boolean if it's a string 'true'/'false'
    const useSandboxBool = typeof useSandbox === 'string'
        ? useSandbox.toLowerCase() === 'true'
        : !!useSandbox; // Ensure boolean
    console.log('useSandboxBool', useSandboxBool);
    console.log('environment', environment);
    console.log('previewApiBaseUrl', previewApiBaseUrl);
    console.log('defaultApiUrl', defaultApiUrl);
    console.log('sandboxApiUrl', sandboxApiUrl);
    console.log('localDevelopmentApiUrl', localDevelopmentApiUrl);
    /*
     * Priority 1: Preview environment with explicit preview URL
     */
    if (environment === 'preview' && !!previewApiBaseUrl) {
        console.log('[API Client] Using preview API base URL:', previewApiBaseUrl);
        return previewApiBaseUrl;
    }
    /*
     * Priority 2: Local development without sandbox flag
     */
    if (environment === 'development' && !useSandboxBool) {
        console.log('[API Client] Using local development API base URL');
        return localDevelopmentApiUrl;
    }
    /*
     * Priority 3: Explicit sandbox usage or preview without specific URL
     */
    if (environment === 'preview' || useSandboxBool) {
        console.log('[API Client] Using sandbox API base URL');
        return sandboxApiUrl;
    }
    /*
     * Priority 4: ONLY production environment gets production URL
     * This is the critical safety check - production URLs require explicit opt-in
     */
    if (environment === 'production') {
        console.log('[API Client] Using production API base URL (environment=production)');
        return defaultApiUrl;
    }
    /*
     * FAIL-SAFE: For any undefined, empty, or unexpected environment value,
     * fall back to SANDBOX, not production. This prevents preview/staging
     * deployments from accidentally connecting to production.
     */
    console.warn(`[API Client] SAFETY FALLBACK: Environment "${environment}" is not explicitly ` +
        `recognized. Using sandbox API URL to prevent accidental production access. ` +
        `Set environment to "production" explicitly to use production API.`);
    return sandboxApiUrl;
}
//# sourceMappingURL=base-url.js.map